import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, CircularProgress } from '@material-ui/core'

import { PrivateRouter } from './private.router'
import { PublicRouter } from './public.router'
import { setAuthData, setGlobalLoading } from '../../features/global'
import { loadLocalStorage, removeLocalStorageKey } from '../../core/utils'

export const BootstrapRouter = () => {
  const dispatch = useDispatch()
  const { isLoading } = useSelector((state) => state.global)
  const { isAuthorized } = useSelector((state) => state.global.authData)
  const localAuthData = loadLocalStorage('userData')

  useEffect(() => {
    removeLocalStorageKey('obfuscation')
    if (!isAuthorized && localAuthData?.access_token) {
      const payload = { ...localAuthData, isAuthorized: true }
      dispatch(setAuthData(payload))
    } else {
      dispatch(setGlobalLoading(false))
    }
  }, []) // eslint-disable-line

  return useMemo(
    () =>
      isLoading ? (
        <Box display="flex" height="100vh" justifyContent="center" alignItems="center">
          <CircularProgress size={40} />
        </Box>
      ) : !isAuthorized ? (
        <PublicRouter />
      ) : (
        <>
          <PrivateRouter />
        </>
      ),
    [isLoading, isAuthorized]
  )
}
